import { render, staticRenderFns } from "./GenAiDonut.vue?vue&type=template&id=6bc19065&scoped=true&"
import script from "./GenAiDonut.vue?vue&type=script&lang=ts&"
export * from "./GenAiDonut.vue?vue&type=script&lang=ts&"
import style0 from "./GenAiDonut.vue?vue&type=style&index=0&id=6bc19065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc19065",
  null
  
)

export default component.exports